import {useEffect} from "react"

/**
 * @template T
 * @param {T & string & keyof WindowEventMap} type
 * @param {(this: Window, ev: WindowEventMap[T]) => void} listener
 * @param {boolean | AddEventListenerOptions} [options]
 */
export function useWindowEvent(type, listener, options) {
  useEffect(() => {
    window.addEventListener(type, listener, options)
    return () => window.removeEventListener(type, listener, options)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}
